import React from 'react';
import PropTypes from 'prop-types';
import { styled, Toolbar, Box, Grid, TableCell, Tooltip, TableHead, Icon as MuiIcon, TableFooter } from '@mui/material';
import { Accordion, Typography } from '@totalsoft/rocket-ui';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';

export const ListFilterToolbar = styled(Toolbar)(({ theme }) => ({
  padding: `${theme.spacing(0)} !important`
}));

export const BoxActionsWrapper = styled(Box, { shouldForwardProp: prop => !['forDialog'].includes(prop) })(({ theme, forDialog }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginInline: forDialog ? theme.spacing(1) : 0,
  marginBottom: forDialog ? theme.spacing(1) : 0
}));

export const GridActionsWrapper = styled(Grid, { shouldForwardProp: prop => !['horizontalSpacing'].includes(prop) })(
  ({ theme, horizontalSpacing = false }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    marginInline: horizontalSpacing ? theme.spacing(1) : 0
  })
);

export const DetatchedAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  marginBottom: `${theme.spacing(1)} !important`,
  '&::before': {
    display: 'none'
  }
}));

export const EllipsisTableCell = styled(TableCell, { shouldForwardProp: prop => !['fontSize'].includes(prop) })(({ fontSize }) => ({
  fontSize: `${fontSize || 15}px`,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
}));

export const GapGrid = styled(Grid, { shouldForwardProp: prop => !['gap', 'direction'].includes(prop) })(
  ({ theme, gap = 0, direction = 'column' }) => ({
    gap: theme.spacing(gap),
    display: 'flex',
    flexDirection: direction
  })
);

export const ThemedTableCell = styled(TableCell, { shouldForwardProp: prop => !['color'].includes(prop) })(({ theme, color }) => ({
  color: theme.palette[color]?.main
}));

export const ThemedTypography = styled(Typography, { shouldForwardProp: prop => !['color'].includes(prop) })(({ theme, color }) => ({
  color: theme.palette[color]?.main || theme.palette.primary.main
}));

export const StylableTooltip = ({ className, ...props }) => <Tooltip {...props} classes={{ tooltip: className }} />;

StylableTooltip.propTypes = {
  className: PropTypes.object.isRequired
};

export const DenseTableCell = styled(TableCell)(({ theme }) => ({
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1)
}));

export const StickyTableFooter = styled(TableFooter)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  background: theme.palette.background.default,
  '& > tr > td': {
    fontSize: theme.spacing(2),
    color: theme.palette.common.black,
    borderTop: `${theme.spacing(0.2)} solid ${theme.palette.grey[300]}`
  }
}));

export const ListEditLink = styled(Link)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(1),
  right: theme.spacing(1)
}));

export const ListEditIcon = styled(EditIcon, { shouldForwardProp: prop => !['size'].includes(prop) })(({ theme, size }) => ({
  width: theme.spacing(size === 'small' ? 2.3 : 2.5),
  height: theme.spacing(size === 'small' ? 2.3 : 2.5)
}));

export const BoldTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const Icon = styled(MuiIcon, { shouldForwardProp: prop => !['size'].includes(prop) })(({ theme, size = 3 }) => ({
  width: theme.spacing(size),
  height: theme.spacing(size)
}));

export const SliderWrapper = styled(Box)(({ theme }) => ({
  '& .MuiTextField-root': {
    paddingTop: theme.spacing(2)
  },
  '& .MuiInputLabel-root': {
    top: theme.spacing(1)
  },
  '& .MuiSlider-root': {
    paddingBottom: 0,
    top: `${theme.spacing(0.5)} !important`
  }
}));
